module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_",
    attrs: {
      "id": "id_Hlk61959347"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_1"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Kirk Shamley is an average guy forever in search of a good story. He lives with his wife and cat while braving the wind-swept plains of Wyoming.")]), _vm._v(" "), _c('p', {
    staticClass: "block_3",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0181da99","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_000.vue
// module id = 63
// module chunks = 0